export default "__VITE_ASSET__yQ7aQj6s__"